import { AnalysisToolbar } from '@modules/analysis/components/AnalysisToolbar';
import { AnalysisBanner } from '@modules/common/components/AnalysisBanner';
import {
  useGetSaveSearchActionType,
  useGetSearchAnalysisActions,
} from '@modules/feed/components/SearchAnalysisToolbar/hooks';
import { Stack } from '@mui/material';
import { createAnalyticsTracker } from 'v2/analytics/events';
import { SearchActionType } from './Actions/SaveSearchActions';

export const trackSearchV2Events = createAnalyticsTracker('searchV2');

export const SearchAnalysisToolbar = () => {
  const { leftActions, rightActions, moreActions } =
    useGetSearchAnalysisActions();
  const actionType = useGetSaveSearchActionType();

  const bannerNode =
    actionType === SearchActionType.SAVE_AS ? (
      <AnalysisBanner>
        This Search wasn't created by you, edits can be saved as a new Search.
      </AnalysisBanner>
    ) : null;

  return (
    <Stack pt={1}>
      <AnalysisToolbar
        leftActions={leftActions}
        rightActions={rightActions}
        moreActions={moreActions}
        bannerNode={bannerNode}
      />
    </Stack>
  );
};
